import { useEffect, useCallback } from 'react';
export const useTinyMcePopoverLifecycle = ({
  editor,
  onRemove = () => {},
  onNodeChange = () => {},
  eventKey
}) => {
  const blurEvents = editor.settings.blurEvents ? `blur ${editor.settings.blurEvents}` : 'blur';
  const handleEditorBlur = useCallback(() => {
    setTimeout(onRemove);
  }, [onRemove]);
  const handleEditorRemove = useCallback(() => {
    if (!editor.settings.inline && editor.getWin() && editor.getWin().removeEventListener) {
      editor.getWin().removeEventListener('scroll', onRemove);
    }
    onRemove();
  }, [editor, onRemove]);
  useEffect(() => {
    // When TinyMCE is in inline mode, the popover and the target are rendered in the same
    // window so we don't have to worry about the target being masked by the parent window
    if (!editor.settings.inline) {
      // Toolbar components are rendered before the editor is setup - need to wait to add the events
      // if the editor's window is not yet available
      if (editor.getWin()) {
        editor.getWin().addEventListener('scroll', onRemove);
      } else {
        editor.on('init', () => {
          editor.getWin().addEventListener('scroll', onRemove);
        });
      }
    }

    // Add remove handler to the front of the event queue
    // so that the handler is more likely to run before the
    // iframe is destroyed
    editor.on('remove', handleEditorRemove, true);
    editor.on(blurEvents, handleEditorBlur);
    return () => {
      if (!editor.removed) {
        editor.getWin().removeEventListener('scroll', onRemove);
        editor.off('remove', handleEditorRemove);
        editor.off(blurEvents, handleEditorBlur);
      }
    };
  }, [editor, onRemove, blurEvents, handleEditorBlur, handleEditorRemove]);
  useEffect(() => {
    if (eventKey) {
      editor.on(`hsNodeChange:${eventKey}`, onNodeChange);
      return () => {
        editor.off(`hsNodeChange:${eventKey}`, onNodeChange);
      };
    }
  }, [editor, eventKey, onNodeChange]);
};